import { styled, TextField } from '@material-ui/core'

export const ColorChooser = styled(TextField)({
  '& input': {
    padding: 0,
    minHeight: 32,
    minWidth: 32,
    border: 0,
  },
})

ColorChooser.defaultProps = {
  type: 'color',
  variant: 'outlined',
}
